module.exports = __webpack_public_path__ + "static/media/SF_bm_primaerlogo_rogaland_pos.39164c5f.pdf";